module.exports = __webpack_public_path__ + "static/media/15_tn.aef7d61d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/thumbnails/15_tn.jpg
// module id = 153
// module chunks = 0